import store from '@/store';

export const createPermissionChecker = permissionName => () => store.getters['auth/getAuthPermissions'](permissionName)?.value === 'true';

export const createAppAccessChecker = appCode => () => store.getters['auth/profileAppCodes'].includes(appCode);
